<template>
  <div class="login-container">
    <div class="top-head">
      <div class="base-warpper minWidth">
        <div class="head-logo">
          <!-- eslint-disable-next-line -->
          <img :src="appConfig.logo_dark" alt="" />
        </div>
        <ul class="single-menu">
          <li><a href="https://itf.sjtu.edu.cn/" target="_blank" title="学院首页">学院首页</a></li>
          <!-- <li><a href="https://itf.sjtu.edu.cn/index/sitemap" target="_blank" title="帮助中心">帮助中心</a></li> -->
          <li><a href="https://itf.sjtu.edu.cn/page-contactus.html" target="_blank" title="联系我们">联系我们</a></li>
        </ul>
      </div>
    </div>
    <div class="container-box">
      <!-- eslint-disable-next-line -->
      <img class="logo" :src="appConfig.logo_dark" alt="" />
      <!-- eslint-disable-next-line -->
      <p class="title" v-html="appConfig.student_login_title"></p>

      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" label-width="0" hide-required-asterisk label-position="left">
        <el-form-item prop="username">
          <el-input
            ref="username"
            v-model="loginForm.username"
            prefix-icon="el-icon-user"
            placeholder="请输入学号"
            name="username"
            clearable
            type="text"
            tabindex="1"
            auto-complete="newUserName"
          />
        </el-form-item>

        <el-form-item prop="password" class="pwdFormItem">
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
            show-password
            clearable
            name="password"
            auto-complete="newpassword"
            @keyup.enter.native="handleLogin"
          />
          <div class="tips"><el-button type="text" @click="forgetPassword">忘记密码？</el-button></div>
        </el-form-item>

        <el-button class="login-btn" :loading="loading" type="primary" @click.native.prevent="handleLogin">登 录</el-button>
      </el-form>
      <div class="tips-web">
        为了您的使用体验，建议使用
        <el-link href="https://www.google.cn/intl/zh-CN/chrome/thank-you.html?statcb=0&installdataindex=empty&defaultbrowser=0" type="primary">Google Chrome</el-link>浏览器访问
      </div>
    </div>
    <div class="footer-login">Copyright 2022 @ 上海交通大学中银科技金融学院</div>
  </div>
</template>

<script>
import defaultSettings from '@/settings'
import { mapGetters } from 'vuex'
import { returnFullPath } from '@/utils'

export default {
  data() {
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        // username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined
    }
  },
  computed: {
    systemSide() {
      return defaultSettings.side
    },
    ...mapGetters(['appConfig'])
  },
  watch: {
    $route: {
      // eslint-disable-next-line
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  beforeCreate() {
    this.$store.dispatch('app/getSysteamSetting')
  },
  methods: {
    returnFullPath,
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('user/Login', this.loginForm)
            .then(() => {
              console.log(this.redirect)

              // this.$router.push({ path: this.redirect || '/' })
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 忘记密码
    forgetPassword() {
      this.$router.push({ path: '/change-password' })
    }
  }
}
</script>

<style lang="scss" scoped>
$bg: #f2f2f2;
$red: #c14e4e;

.minWidth {
  min-width: 1200px !important;
  padding: 0 20px;
}

:deep(.el-input__inner) {
  height: 46px;
  line-height: 46px;
  border-radius: 46px;
}
:deep(.el-input) {
  font-size: 16px;
}
.container-box {
  width: 500px;
  box-shadow: 0px 8px 14px 0px #ececec;
  padding: 44px 35px 35px 35px;
  border-radius: 14px;
}
.icon {
  margin-left: 10px;
  font-size: 15px;
  color: #ffffff;
}
.title {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  color: #606266;
  // margin-top: 80px;
}
.login-container {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: url('@/assets/login-bg.svg') no-repeat;
  background-size: 100% 100%;
  background-color: linear-gradient(180deg, #f6f9ff 0%, #fefefe 100%);
  .logo {
    width: 100%;
    display: block;
    margin: 0 auto;
    height: auto;
  }

  .login-btn {
    width: 100%;
    height: 46px;
    border-radius: 23px;
    font-size: 16px;
    margin-top: 25px;
  }

  .login-form {
    width: 400px;
    max-width: 100%;
    margin: 0 auto;
  }

  .pwdFormItem {
    position: relative;

    .tips {
      position: absolute;
      right: 0;
      font-size: 14px;
      color: $red;
      margin: 0 auto;
      text-align: right;
    }
  }
}

.tips-web {
  font-size: 14px;
  text-align: center;
  color: #999999;
  margin-top: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top-head {
  width: 100%;
  height: 66px;
  background: #ffffff;
  box-shadow: 0px 2px 28px 0px rgba(0, 0, 0, 0.05);
  > div {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .head-logo {
    width: 328px;
    height: 40px;
    // background-image: url('@/assets/logo-red.png');
    // background-size: 100% 100%;
    img {
      display: block;
      width: 100%;
    }
  }
  .single-menu {
    display: flex;
    margin: 0;
    padding: 0;
    justify-content: flex-start;
    align-items: center;
    li {
      list-style: none;
      a {
        color: #777777;
      }
      &:hover {
        a {
          color: var(--theme-color);
        }
      }
      &:not(:last-child) {
        &::after {
          content: '|';
          margin: 0 20px;
          color: #777777;
        }
      }
    }
  }
}

.footer-login {
  position: relative;
  height: 66px;
  line-height: 66px;
  font-size: 14px;
  color: #999999;
  &::before {
    content: '';
    position: absolute;
    left: -500px;
    top: -363px;
    display: block;
    width: 317px;
    height: 429px;
    background-image: url('@/assets/build.svg');
  }
}
</style>
